import { render } from "./NavbarMobileCSSOnly.vue?vue&type=template&id=5106aa1b&scoped=true"
import script from "./NavbarMobileCSSOnly.vue?vue&type=script&lang=js"
export * from "./NavbarMobileCSSOnly.vue?vue&type=script&lang=js"

import "./NavbarMobileCSSOnly.vue?vue&type=style&index=0&id=5106aa1b&scoped=true&lang=scss"

import exportComponent from "/builds/dalmadima/umzugbayernwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5106aa1b"]])

export default __exports__